import { Phone, ArrowRight, Flame, Truck, ShieldCheck } from "lucide-react";

export default function Hero({ price }) {
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      {/* Sky background */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, #4F9FD4 0%, #78B7E6 45%, #A9D3F0 85%, #DCE9F3 100%)",
        }}
      />
      {/* Clouds */}
      <div
        className="absolute inset-0 opacity-55 mix-blend-screen"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1505533542167-8c89838bb019?q=80&w=2000&auto=format&fit=crop')",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-20 pb-20 md:pb-28 grid md:grid-cols-12 gap-10 items-center">
        {/* LEFT: Headline & CTAs */}
        <div className="md:col-span-6 relative">
          <div className="inline-flex items-center gap-2 bg-brand-gold text-brand-navy px-3 py-1 mb-5 border-2 border-brand-navy font-heading tracking-[0.15em] text-xs shadow-[3px_3px_0_#0A1128]" data-testid="hero-eyebrow">
            <Flame size={14} /> LONG ISLAND · NY
          </div>

          <h1
            className="font-heading tracking-tight leading-[1.08] mb-6"
            style={{
              fontSize: "clamp(32px, 5vw, 76px)",
              color: "#0A1128",
              textShadow: "2px 2px 0 rgba(255,255,255,0.6)",
            }}
            data-testid="hero-headline"
          >
            Heating Oil
            <br />
            <span
              className="inline-block"
              style={{
                color: "#D00017",
                WebkitTextStroke: "1px #0A1128",
                textShadow: "3px 3px 0 #FFD100",
                paddingBottom: "6px",
              }}
            >
              Delivered Right
            </span>
            <br />
            to Your Door.
          </h1>

          <p className="text-brand-navy/85 text-lg leading-relaxed mb-8 max-w-md">
            Family-owned, licensed, and always on-call. Order online in under a minute or talk to a real dispatcher — we'll keep your tank topped off all winter.
          </p>

          <div className="flex flex-wrap items-center gap-3 mb-10">
            <a
              href="#order"
              className="group inline-flex items-center gap-2 bg-brand-red hover:bg-brand-redDark text-white px-7 py-4 font-heading tracking-wide border-2 border-brand-navy shadow-[6px_6px_0_#0A1128] hover:shadow-[10px_10px_0_#0A1128] hover:-translate-x-1 hover:-translate-y-1 transition-all"
              data-testid="hero-order-cta"
            >
              Request a Quote
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="tel:6313723526"
              className="inline-flex items-center gap-2 bg-white hover:bg-brand-gold text-brand-navy px-6 py-4 font-heading tracking-wide border-2 border-brand-navy transition-colors"
              data-testid="hero-call-cta"
            >
              <Phone size={18} /> 631-372-3526
            </a>
          </div>

          {/* Trust row */}
          <div className="grid grid-cols-2 gap-2 max-w-md">
            {[
              { Icon: Flame, k: "24/7", v: "Emergency" },
              { Icon: ShieldCheck, k: "Licensed", v: "& Insured" },
            ].map((it, i) => (
              <div key={i} className="bg-white/90 border-2 border-brand-navy px-3 py-3 text-brand-navy">
                <it.Icon size={16} className="text-brand-red mb-1" />
                <div className="font-heading text-lg leading-none">{it.k}</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-brand-navy/70 mt-1">{it.v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: Truck + Long Island map */}
        <div className="md:col-span-6 relative">
          <div className="relative">
            <div className="absolute -inset-3 bg-brand-gold rotate-3"></div>
            <div className="absolute -inset-2 bg-brand-red -rotate-2"></div>
            <div className="absolute -inset-1 bg-brand-navy rotate-1"></div>
            <div className="relative overflow-hidden border-4 border-white">
              <img
                src="https://customer-assets.emergentagent.com/job_heat-dispatch/artifacts/fyrweybp_image.png"
                alt="McFly's Fuel Inc. delivery truck on Long Island — serving Hempstead, Huntington, Smithtown, Riverhead, Greenport, and beyond"
                className="w-full h-auto object-contain block"
                data-testid="hero-truck-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="relative h-2 bg-brand-navy"></div>
    </section>
  );
}
